// extracted by mini-css-extract-plugin
export default {"Summary":"Summary_Summary__7d2IU","title":"Summary_title__WZ98k","text":"Summary_text__oXJlo","actions":"Summary_actions__dQWfE"};